// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.blank-container[data-v-eb4ce10a]{height:100%;margin:0 auto}", ""]);
// Exports
module.exports = exports;
